import { format, formatDistanceToNowStrict, parseISO, isValid } from "date-fns";
import { nn } from "date-fns/locale";

export const fmtKr = (n) => {
  const num = Number(n || 0);
  const whole = Math.abs(num - Math.round(num)) < 0.005;
  const s = whole ? Math.round(num).toLocaleString("nb-NO") : num.toLocaleString("nb-NO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${s.replace(/\u00a0/g, " ")} kr`;
};

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  const d = parseISO(iso);
  if (!isValid(d)) return iso;
  return format(d, "d. MMMM 'kl.' HH:mm", { locale: nn });
};

export const timeLeft = (iso) => {
  if (!iso) return "";
  const d = parseISO(iso);
  if (!isValid(d) || d < new Date()) return "";
  return formatDistanceToNowStrict(d, { locale: nn, addSuffix: false });
};

export const STATUS = {
  reserved: { label: "Ventar på betaling", tone: "pending" },
  payment_check: { label: "Treng betalingskontroll", tone: "warning" },
  confirmed: { label: "Stadfesta", tone: "ok" },
  waitlist: { label: "Venteliste", tone: "muted" },
  expired: { label: "Utgått", tone: "off" },
  cancelled: { label: "Avbestilt", tone: "off" },
};

export const TONE_CLASS = {
  pending: "border-sol/50 bg-sol/15 text-foreground",
  warning: "border-status-warning/50 bg-[hsl(var(--status-warning-bg))] text-foreground",
  ok: "border-emerald-700/30 bg-emerald-700/10 text-emerald-800",
  muted: "border-border bg-secondary text-muted-foreground",
  off: "border-border bg-secondary text-muted-foreground line-through",
};

export const MODE_LABEL = { free: "Gratis påmelding", door: "Betal i døra", vipps_manual: "Vipps til arrangør" };
export const DOOR_PAYMENT_LABEL = { cash: "Kontant", vipps: "Vipps" };

/** Where the buyer wants the ticket. Offered only while the house has SMS on (`av.sms_available`). */
export const NOTIFY = [
  { value: "email", label: "E-post", via: "på e-post" },
  { value: "sms", label: "SMS", via: "på SMS" },
  { value: "both", label: "Begge", via: "på e-post og SMS" },
];
export const viaText = (notify) => (NOTIFY.find((n) => n.value === notify) || NOTIFY[0]).via;
export const needsEmail = (notify) => notify !== "sms";
export const needsPhone = (notify) => notify === "sms" || notify === "both";
/** The SMS surcharge for this channel choice – the server is the authority, this only mirrors it for the form. */
export const smsFeeFor = (av, notify) => (av?.sms_fee?.enabled && needsPhone(notify) ? Number(av.sms_fee.amount) || 0 : 0);
export const isEmail = (v) => /.+@.+\..+/.test(v || "");
/** Same rule as the server: 8 digits (Norwegian mobile), or +/00 and 8–15 digits. */
export const isPhone = (v) => {
  let s = (v || "").replace(/[^\d+]/g, "");
  if (s.startsWith("00")) s = `+${s.slice(2)}`;
  return s.startsWith("+") ? /^\+\d{8,15}$/.test(s) : /^\d{8}$/.test(s) || /^47\d{8}$/.test(s);
};

/** «– meldinga går kl. 08:00 (nattestopp)» when the order has notifications waiting for the morning. */
export const queuedNote = (order) => {
  const q = order?.queued_notifications;
  if (!q || !Object.keys(q).length) return "";
  const due = Object.values(q).map((x) => x?.due_at).filter(Boolean).sort()[0];
  const d = due ? parseISO(due) : null;
  return d && isValid(d) ? ` – meldinga går ${format(d, "d. MMM", { locale: nn })} kl. ${format(d, "HH:mm")} (nattestopp)` : " – meldinga går kl. 08:00 (nattestopp)";
};

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
